import { useQuery } from '@tanstack/react-query'

import config from '@config'
import { SportEntityScheduleItem } from '@hooks/useSportEntitySchedule/types'

type AllowedTypeOfSport = 'soccer'

export interface UseFmtRelevantMatchesProps {
  competitorIds: string[]
  typeOfSport: AllowedTypeOfSport
}

export type FmtRelevantMatchesAPIResponse = {
  items: SportEntityScheduleItem[]
}

const {
  sports: { baseUrlV2: sportsBaseUrlV2, fmtRelevantMatchesUrlTemplateV2 },
} = config

const fetchFmtRelevantMatchesData = async ({
  typeOfSport,
  competitorIds,
}: {
  typeOfSport: AllowedTypeOfSport
  competitorIds: string[]
}) => {
  const requestUrl = new URL(
    `${sportsBaseUrlV2}${fmtRelevantMatchesUrlTemplateV2}`
      .replace('{SPORT}', typeOfSport)
      .replace('{API_VERSION}', 'v0'),
  )

  competitorIds.forEach((competitorId) => {
    requestUrl.searchParams.append('cId', competitorId)
  })

  const response = await fetch(requestUrl)

  if (!response.ok) {
    throw new Error('Error fetching Relevant Matches.')
  }

  return response.json() as Promise<FmtRelevantMatchesAPIResponse>
}

const useFmtRelevantMatches = ({
  competitorIds,
  typeOfSport,
}: UseFmtRelevantMatchesProps) =>
  useQuery({
    queryKey: [
      'fmtRelevantMatches',
      typeOfSport,
      'competitorIds',
      competitorIds,
    ],
    queryFn: () =>
      fetchFmtRelevantMatchesData({
        competitorIds,
        typeOfSport,
      }),
  })

export default useFmtRelevantMatches
